<img
  class="avatar__image"
  src="{{ url }}?s={{ size }}&amp;d={{ default }}"
  width="{{ size }}"
  height="{{ size }}"
/><span class="avatar__initial">{{ initial }}</span>
